export const CONDITION_OPERATOR_OPTIONS = [
  { value: 'contains', label: '包含' },
  { value: 'not_contains', label: '不包含' },
  { value: 'equals', label: '等于' },
  { value: 'not_equals', label: '不等于' },
  { value: 'regex', label: '正则匹配' },
  { value: 'is_empty', label: '为空' },
  { value: 'is_not_empty', label: '不为空' },
  { value: 'ai_judge', label: 'AI 判断' },
  { value: 'date_gt', label: '日期大于' },
  { value: 'date_lt', label: '日期小于' },
  { value: 'date_gt_days', label: '大于当前时间天数' },
  { value: 'date_lt_days', label: '小于当前时间天数' },
  { value: 'date_past_within', label: '过去N天内' },
  { value: 'date_future_within', label: '未来N天内' }
];

export const ACTION_TYPE_OPTIONS = [
  { value: 'assign', label: '分配工单' },
  { value: 'update_priority', label: '更新优先级' },
  { value: 'transition', label: '状态转换' },
  { value: 'set_field', label: '设置字段值' },
  { value: 'salesforce_customer_sync', label: 'Salesforce 客户信息回填' },
  { value: 'ai_set_field', label: 'AI 生成并设置字段' },
  { value: 'send_https_request', label: '发送 HTTPS 请求' },
  { value: 'add_comment', label: '添加评论' },
  { value: 'noop', label: '不执行任何操作' }
];

export const ASSIGNMENT_STRATEGY_OPTIONS = [
  { value: 'first', label: '分配给第一个人' },
  { value: 'random', label: '随机分配' },
  { value: 'sequence', label: '顺序分配' }
];
